import React from 'react';
import PropTypes from 'prop-types';

const Link = props => (
  <a className="button" href={props.href}>
    {props.icon && <img className="button_icon" src={props.icon} alt="icono" />}
    {props.children}
  </a>
);

Link.propTypes = {
  href: PropTypes.string.isRequired,
  children: PropTypes.node,
  icon: PropTypes.node
};

Link.defaultProps = {
  children: undefined,
  icon: undefined
};

export default Link;
